import { render, staticRenderFns } from "./tabArticle.vue?vue&type=template&id=74756bb4&scoped=true&"
import script from "./tabArticle.vue?vue&type=script&lang=js&"
export * from "./tabArticle.vue?vue&type=script&lang=js&"
import style0 from "./tabArticle.vue?vue&type=style&index=0&id=74756bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74756bb4",
  null
  
)

export default component.exports